/**
 * MHS Hero Slideshow — mhs-hero-slideshow.js
 * Powered by GSAP (loaded from CDN).
 * Unique prefix: mhs_
 */

(function () {
  'use strict';

  /* ── GSAP CDN loader ─────────────────────────────────── */
  function mhs_loadGSAP(callback) {
    if (window.gsap) { callback(); return; }
    var script = document.createElement('script');
    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js';
    script.onload = callback;
    script.onerror = function () {
      console.warn('[MHS Slideshow] GSAP failed to load; falling back to CSS transitions.');
      mhs_initAll(true);
    };
    document.head.appendChild(script);
  }

  /* ── Initialise all slideshow instances on the page ──── */
  function mhs_initAll(fallback) {
    var slideshows = document.querySelectorAll('.mhs-slideshow');
    slideshows.forEach(function (el) { mhs_initOne(el, fallback); });
  }

  /* ── Single instance initialisation ────────────────── */
  function mhs_initOne(wrapper, fallback) {
    var sectionId    = wrapper.id.replace('mhs-slideshow-', '');
    var slides       = Array.from(wrapper.querySelectorAll('.mhs-slide'));
    if (slides.length < 1) return;

    var autoplay        = wrapper.dataset.autoplay === 'true';
    var autoplaySpeed   = (parseFloat(wrapper.dataset.autoplaySpeed) || 5) * 1000;
    var transitionMs    = parseFloat(wrapper.dataset.transitionDuration) || 800;
    var transitionSec   = transitionMs / 1000;

    var currentIndex  = 0;
    var isAnimating   = false;
    var isPaused      = false;
    var autoplayTimer = null;

    var prevBtn  = wrapper.querySelector('#mhs-prev-'  + sectionId);
    var nextBtn  = wrapper.querySelector('#mhs-next-'  + sectionId);
    var dotsWrap = wrapper.querySelector('#mhs-dots-'  + sectionId);
    var dots     = dotsWrap ? Array.from(dotsWrap.querySelectorAll('.mhs-dot')) : [];
    var pauseBtn = wrapper.querySelector('#mhs-pause-' + sectionId);

    /* ── Set up initial GSAP states ────────────────────── */
    if (!fallback && window.gsap) {
      slides.forEach(function (slide, i) {
        if (i === 0) {
          gsap.set(slide, { autoAlpha: 1, zIndex: 2, position: 'relative' });
        } else {
          gsap.set(slide, { autoAlpha: 0, zIndex: 1, position: 'absolute', top: 0, left: 0, width: '100%' });
        }
      });
    } else {
      slides.forEach(function (slide, i) {
        slide.style.display = i === 0 ? 'block' : 'none';
      });
    }

    /* ── Core transition ────────────────────────────────── */
    function mhs_goTo(targetIndex, direction) {
      if (isAnimating || targetIndex === currentIndex) return;
      if (targetIndex < 0) targetIndex = slides.length - 1;
      if (targetIndex >= slides.length) targetIndex = 0;

      isAnimating = true;
      var outgoing = slides[currentIndex];
      var incoming = slides[targetIndex];

      if (!fallback && window.gsap) {
        gsap.set(incoming, { autoAlpha: 0, zIndex: 2, scale: 1.04 });
        gsap.set(outgoing, { zIndex: 1 });

        var wrapperHeight = outgoing.offsetHeight;
        wrapper.style.height = wrapperHeight + 'px';

        var tl = gsap.timeline({
          defaults: { ease: 'power2.inOut' },
          onComplete: function () {
            gsap.set(outgoing, { autoAlpha: 0, position: 'absolute', scale: 1 });
            gsap.set(incoming, { position: 'relative', zIndex: 2 });
            wrapper.style.height = '';
            currentIndex = targetIndex;
            isAnimating  = false;
            mhs_updateDots(targetIndex);
            mhs_resetAutoplay();
          }
        });

        tl
          .to(outgoing, { autoAlpha: 0, scale: 0.97, duration: transitionSec * 0.6 }, 0)
          .to(incoming, { autoAlpha: 1, scale: 1,    duration: transitionSec }, 0);

        var contentEls = incoming.querySelectorAll(
          '.mhs-slide__subheading, .mhs-slide__heading, .mhs-slide__description, .mhs-btn'
        );
        if (contentEls.length) {
          gsap.fromTo(contentEls,
            { y: 22, autoAlpha: 0 },
            { y: 0, autoAlpha: 1, stagger: 0.08, duration: transitionSec * 0.6, ease: 'power3.out', delay: transitionSec * 0.35 }
          );
        }

      } else {
        outgoing.style.display = 'none';
        outgoing.classList.remove('mhs-slide--active');
        incoming.style.display = 'block';
        incoming.classList.add('mhs-slide--active');
        currentIndex = targetIndex;
        isAnimating  = false;
        mhs_updateDots(targetIndex);
        mhs_resetAutoplay();
      }
    }

    /* ── Dots ──────────────────────────────────────────────── */
    function mhs_updateDots(activeIdx) {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('mhs-dot--active', i === activeIdx);
        dot.setAttribute('aria-selected', i === activeIdx ? 'true' : 'false');
      });
    }

    /* ── Autoplay ─────────────────────────────────────────── */
    function mhs_startAutoplay() {
      if (!autoplay || isPaused) return;
      mhs_clearAutoplay();
      autoplayTimer = setInterval(function () {
        mhs_goTo(currentIndex + 1, 'next');
      }, autoplaySpeed);
    }

    function mhs_clearAutoplay() {
      if (autoplayTimer) { clearInterval(autoplayTimer); autoplayTimer = null; }
    }

    function mhs_resetAutoplay() {
      if (!isPaused) mhs_startAutoplay();
    }

    /* ── Hover pause ───────────────────────────────────────── */
    wrapper.addEventListener('mouseenter', function () { mhs_clearAutoplay(); });
    wrapper.addEventListener('mouseleave', function () { if (!isPaused) mhs_startAutoplay(); });

    /* ── Arrow buttons ────────────────────────────────────── */
    if (prevBtn) prevBtn.addEventListener('click', function () { mhs_goTo(currentIndex - 1, 'prev'); });
    if (nextBtn) nextBtn.addEventListener('click', function () { mhs_goTo(currentIndex + 1, 'next'); });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        mhs_goTo(i, i > currentIndex ? 'next' : 'prev');
      });
    });

    /* ── Pause/play toggle ───────────────────────────────── */
    if (pauseBtn) {
      pauseBtn.addEventListener('click', function () {
        isPaused = !isPaused;
        var iconPause = pauseBtn.querySelector('.mhs-icon-pause');
        var iconPlay  = pauseBtn.querySelector('.mhs-icon-play');
        if (isPaused) {
          mhs_clearAutoplay();
          if (iconPause) iconPause.style.display = 'none';
          if (iconPlay)  iconPlay.style.display  = 'block';
          pauseBtn.setAttribute('aria-label', 'Play slideshow');
        } else {
          mhs_startAutoplay();
          if (iconPause) iconPause.style.display = 'block';
          if (iconPlay)  iconPlay.style.display  = 'none';
          pauseBtn.setAttribute('aria-label', 'Pause slideshow');
        }
      });
    }

    /* ── Touch / swipe ─────────────────────────────────────── */
    var mhs_touchStartX = 0;
    var mhs_touchEndX   = 0;

    wrapper.addEventListener('touchstart', function (e) {
      mhs_touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    wrapper.addEventListener('touchend', function (e) {
      mhs_touchEndX = e.changedTouches[0].screenX;
      var diff = mhs_touchStartX - mhs_touchEndX;
      if (Math.abs(diff) > 50) {
        mhs_goTo(diff > 0 ? currentIndex + 1 : currentIndex - 1, diff > 0 ? 'next' : 'prev');
      }
    }, { passive: true });

    /* ── Keyboard ─────────────────────────────────────────── */
    wrapper.setAttribute('tabindex', '0');
    wrapper.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  mhs_goTo(currentIndex - 1, 'prev');
      if (e.key === 'ArrowRight') mhs_goTo(currentIndex + 1, 'next');
    });

    /* ── Reduced motion ─────────────────────────────────────── */
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) fallback = true;

    /* ── Animate first slide content in ───────────────────── */
    if (!fallback && window.gsap && slides.length > 0) {
      var firstContentEls = slides[0].querySelectorAll(
        '.mhs-slide__subheading, .mhs-slide__heading, .mhs-slide__description, .mhs-btn'
      );
      if (firstContentEls.length) {
        gsap.fromTo(firstContentEls,
          { y: 24, autoAlpha: 0 },
          { y: 0, autoAlpha: 1, stagger: 0.09, duration: 0.8, ease: 'power3.out', delay: 0.2 }
        );
      }
    }

    /* ── Shopify theme editor ─────────────────────────────── */
    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function (e) {
        if (e.detail && wrapper.id.includes(e.detail.sectionId)) {
          mhs_clearAutoplay();
          mhs_startAutoplay();
        }
      });
      document.addEventListener('shopify:block:select', function (e) {
        if (!wrapper.contains(e.target)) return;
        var idx = slides.indexOf(e.target);
        if (idx >= 0) mhs_goTo(idx, idx > currentIndex ? 'next' : 'prev');
      });
    }

    /* ── Kick off ───────────────────────────────────────────── */
    mhs_startAutoplay();
  }

  /* ── Bootstrap ──────────────────────────────────────────── */
  function mhs_bootstrap() {
    if (document.querySelector('.mhs-slideshow')) {
      mhs_loadGSAP(function () { mhs_initAll(false); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mhs_bootstrap);
  } else {
    mhs_bootstrap();
  }

})();
